import { api } from '@shared/api/api';
import { ObjectWithId } from '@shared/utils/types';

type ParkingRequestParkingSticker = App.Domain.Parking.Data.ParkingRequestParkingStickerData;

export function unclaimParkingSticker(eventId: number, { id }: ObjectWithId) {
  return api.post<ParkingRequestParkingSticker>(`/events/${eventId}/parking-request-parking-stickers/${id}/unclaim`);
}
